<template>
  <v-app>
    <transition>
      <router-view></router-view>
    </transition>
  </v-app>
</template>

<script>
export default {
  name: "App",
  methods: {},
  computed: {},
  mounted() {
    // ===> Vuetify Direction

    // myTeam_Academy_Dash_Token;
    // console.log("User country:", country.name);
    // if (this.$store.getters["lang_module/lang"] == "ar") {
    // if (!localStorage.getItem("myTeam_Academy_Dash_Token")) {
    // document.body.dir = "ltr";
    // this.$vuetify.rtl = true;
    // return;
    // }
    const countryString = localStorage.getItem("myTeam_Dash_user_country");
    const country = countryString ? JSON.parse(countryString) : null;
    if (
      country?.name == "مصر" ||
      country === null ||
      country === "null" ||
      country === ""
    ) {
      // console.log("Setting RTL for country:", country?.name);
      document.body.dir = "rtl";
      this.$vuetify.rtl = true;
    } else {
      document.body.dir = "ltr";
      this.$vuetify.rtl = false;
    }

    // ===> Vuetify Theme
    if (this.$store.getters["theme_module/current_theme"] == "light") {
      this.$vuetify.theme.dark = false;
    } else {
      this.$vuetify.theme.dark = true;
    }

    // ===> Scroll To Top Alwayse
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  },
};
</script>
